"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13 20h2.0625v-2H13v2zm0-4.0615c.3199.081.6549.124 1 .124 2.2437 0 4.0625-1.8188 4.0625-4.0625S16.2437 7.9375 14 7.9375c-.3451 0-.6801.043-1 .124v2.2787a1.928 1.928 0 0 1 1-.2777c1.0701 0 1.9375.8674 1.9375 1.9375S15.0701 13.9375 14 13.9375a1.928 1.928 0 0 1-1-.2777v2.2787zM13 6h2.0625V4H13v2zm4.2242 1.2731 1.6905-1.6904 1.5026 1.5026-1.6905 1.6904-1.5026-1.5026zM22 10.9375h-2v2.125h2v-2.125zm-3.2732 4.2869 1.6905 1.6904-1.5026 1.5026-1.6905-1.6904 1.5026-1.5026z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22V2h11v20H1z"
  })];
};

exports.default = _default;